var exports = {
  "HB": "FeedReplies.module__thread___TEJrWV",
  "o1": "FeedReplies.module__actions___TEJrWV",
  "uX": "FeedReplies.module__textButton___TEJrWV",
  "Iq": "FeedReplies.module__authorTag___TEJrWV",
};

module.exports = exports;
